export enum ScraperMessageTypeEnum {
  TRACKING_ID = 'TRACKING_ID',
  TEXT = 'TEXT',
  IMG = 'IMG',
  BANKID_LINK = 'BANKID_LINK',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  CAREPROVIDER__INFO = 'CAREPROVIDER__INFO',
  CAREPROVIDER__NOT_FOUND = 'CAREPROVIDER__NOT_FOUND',
  REGISTER__TERMS = 'REGISTER__TERMS',
  REGISTER__SERVICES = 'REGISTER__SERVICES',
  REGISTER__NOT_POSSIBLE = 'REGISTER__NOT_POSSIBLE',
  REGISTER__WARNING = 'REGISTER__WARNING',
  REGISTER__QUEUE = 'REGISTER__QUEUE',
  REGISTER__NO_WARNINGS = 'REGISTER__NO_WARNINGS',
  REGISTER__DOCTORS = 'REGISTER__DOCTORS',
  REGISTER__PATIENT_NAME = 'REGISTER__PATIENT_NAME',
  TERMS__ACCEPTANCE_REQUIRED = 'TERMS__ACCEPTANCE_REQUIRED',
  LOGIN_TIMEOUT = 'LOGIN_TIMEOUT',
  LOGIN_QUEUE = 'LOGIN_QUEUE',
}
